<template>
	<div class='errorMessage'>
		<p>{{ msg }}</p>
	</div>
</template>

<script>

export default {
	name: 'IWError',
	props: {
		msg: {
			type: String,
			default() {
				return '';
			}
		}
	},
  created: function () {
    //console.log('IWError->created()');
  }
}
</script>

<style scoped>
.errorMessage {
	width: 100%;
	text-align: center;
	margin: 0;
	position: absolute;
	top: 50%;
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
}
</style>
